import React from 'react';
import { Flex } from '@cko/primitives';
import styled from 'styled-components';
const StyledLayout = styled.div `
  display: grid;
  grid-template-columns: 280px auto;
  grid-template-rows: auto min-content;
  grid-column-gap: var(--layout-saxophone);
  grid-template-areas:
    'sidebar main'
    'footer footer';
  height: 100%;
  max-height: 100vh;

  background: var(--base-bg-primary);
`;
const Sidebar = styled.div `
  grid-area: sidebar;
  margin: var(--layout-saxophone) var(--layout-sandgrain) var(--layout-sandgrain)
    var(--layout-saxophone);
`;
const MainContent = styled.div `
  grid-area: main;
  overflow-y: scroll;
  margin-top: var(--layout-saxophone);
  margin-left: calc(var(--layout-saxophone) * -1);
  padding: var(--layout-saxophone);
`;
const Actions = styled(Flex) `
  grid-area: footer;
  justify-content: space-between;
  border-top: var(--border-b-seed) solid var(--base-border-secondary);
  padding: var(--layout-spoon) var(--layout-saxophone);
`;
export const FullPageLayout = ({ children, isForm, onSubmit }) => (React.createElement(StyledLayout, { as: isForm ? 'form' : 'div', onSubmit: onSubmit }, children));
FullPageLayout.Sidebar = Sidebar;
FullPageLayout.MainContent = MainContent;
FullPageLayout.Actions = Actions;
